module.exports = __webpack_public_path__ + "static/media/19_tn.94792078.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/19_tn.jpg
// module id = 328
// module chunks = 0